export default __webpack_public_path__ + "static/media/blogtile.66ccadc1.webp";